import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";

import { ApiConnector } from "../../api/api-connector";
import { hasFeatureFlags } from "../../api/user-feature-flags";
import { UserFeatureFlags } from "../../components/user-feature-flags";
import { Patient } from "./patient";

/**
 * The flag grid for a patient's connected user(s). The card heading lives in
 * the settings page, so the shared grid carries no chrome of its own - the
 * admin dialog names the user in its title instead.
 */
export const PatientFeatureFlags = observer(
  function PatientFeatureFlags(props: { patient: Patient; api: ApiConnector }) {
    const users = (props.patient.data?.connected_users ?? []).filter((user) =>
      hasFeatureFlags(user.feature_flags),
    );

    if (users.length === 0) {
      return (
        <div className="text-muted-foreground">
          <Trans>No connected user.</Trans>
        </div>
      );
    }

    return (
      <div className="flex flex-col gap-4">
        {users.map((user) => (
          <div key={user.uuid}>
            {/* a patient normally has one user; name them only when they do not */}
            {users.length > 1 && (
              <div className="mb-1 font-medium">{user.username}</div>
            )}
            <UserFeatureFlags
              api={props.api}
              flags={user.feature_flags ?? {}}
              onSave={(flag, update) =>
                props.patient.updateConnectedUserFlag(user.uuid, flag, update)
              }
            />
          </div>
        ))}
      </div>
    );
  },
);
